export const LATENT_READING_DIFF_HOURS = 4;
